module.exports = __webpack_public_path__ + "img/album10_12.52974b69.jpg";